import { render, staticRenderFns } from "./MultilinePromoViewer.vue?vue&type=template&id=22a52d54&scoped=true&"
import script from "./MultilinePromoViewer.vue?vue&type=script&lang=js&"
export * from "./MultilinePromoViewer.vue?vue&type=script&lang=js&"
import style0 from "./MultilinePromoViewer.vue?vue&type=style&index=0&id=22a52d54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a52d54",
  null
  
)

export default component.exports